import {AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SwiperOptions} from 'swiper/types';
import {SwiperComponent} from 'swiper/angular';
import {
  SwiperItemInterface,
  SwiperItemsInterface
} from '../../../shared/timeline/social-grid-list/swiper-items.interface';
import {TranslateService} from '@ngx-translate/core';
import {SearchTabsEnum} from './search-tabs.enum';
import Swiper from 'swiper';
import {KeyValue} from '@angular/common';
import {MenuItem} from 'primeng/api';
import {SiteLayoutComponent} from '../../layout/site/site-layout.component';
import {AppBreadcrumbService} from '../../../shared/navbar/app.breadcrumb.service';
import {
  SearchInfiniteListComponent
} from '../../../shared/timeline/search-infinite-list/search-infinite-list.component';
import {ResultsListTabInterface} from './results-list-tab.interface';
import {mergeMap} from "rxjs/operators";
import {ModalService} from "../../../shared/modal/modal.service";
import {AbstractComponent} from "../abstract-component";
import {SeoService} from "../../services/seo.service";
import {environment} from "../../../../environments/environment";
import {CacheRefreshService} from "../../services/cache-refresh.service";
import {HashtagRoutingService} from "../../services/hashtag-routing.service";
import {QueryService} from "../../services/query.service";


@Component({
  selector: 'app-search-result-list',
  templateUrl: './search-results-list.component.html',
  styleUrls: ['./search-results-list.component.scss']
})
export class SearchResultsListComponent extends AbstractComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly defaultTabsFactory = (): ResultsListTabInterface[] => ([
    {label: this.translate.instant('core.search.tabs.all'), type: SearchTabsEnum.ALL, id: 0, filtersAvailable: false},
    {label: this.translate.instant('core.search.tabs.posts'), type: SearchTabsEnum.POSTS, id: 1, filtersAvailable: false},
    {label: this.translate.instant('core.search.tabs.vehicles'), type: SearchTabsEnum.PROJECTS, id: 2, filtersAvailable: true},
    {label: this.translate.instant('core.search.tabs.users'), type: SearchTabsEnum.USERS, id: 3, filtersAvailable: true},
    {label: this.translate.instant('core.search.tabs.events'), type: SearchTabsEnum.EVENTS, id: 4, filtersAvailable: true},
    {label: this.translate.instant('core.search.tabs.marketplace'), type: SearchTabsEnum.MARKETPLACE, id: 5, filtersAvailable: true, filtersMode: 'advanced'},
  ]);
  private readonly tagTabsFactory = (): ResultsListTabInterface[] => ([
    {label: this.translate.instant('core.search.tabs.all'), type: SearchTabsEnum.ALL, id: 0, filtersAvailable: false},
    {label: this.translate.instant('core.search.tabs.posts'), type: SearchTabsEnum.POSTS, id: 1, filtersAvailable: false},
    {label: this.translate.instant('core.search.tabs.vehicles'), type: SearchTabsEnum.PROJECTS, id: 2, filtersAvailable: true},
    {label: this.translate.instant('core.search.tabs.events'), type: SearchTabsEnum.EVENTS, id: 3, filtersAvailable: true},
    {label: this.translate.instant('core.search.tabs.marketplace'), type: SearchTabsEnum.MARKETPLACE, id: 4, filtersAvailable: true, filtersMode: 'advanced'},
  ]);

  public config: SwiperOptions;
  public childConfig: SwiperOptions;
  public slides: SwiperItemsInterface;
  public selectedTab: ResultsListTabInterface;
  public selectedIndex: number = 0;
  public tabs: ResultsListTabInterface[] = [];
  @ViewChild('slaveSwiper') public slaveSwiper: SwiperComponent;
  @ViewChildren(SearchInfiniteListComponent, {emitDistinctChangesOnly: false}) searchInfiniteListComponents: QueryList<SearchInfiniteListComponent>;
  private tabsCount = this.tabs.length - 1;
  public listType: SearchTabsEnum;
  public searchTypes: string[] = [];
  public heading = '';
  public tagSlug: string | null = null;
  public exactTag: string | null = null;
  public isTagMode = false;
  public isTagPage = false;

  get totalResults(): number {
    return this.queryService.totalItems.all || 0;
  }

  get activeResultsCount(): number {
    switch (this.selectedTab?.type) {
      case SearchTabsEnum.POSTS:
        return this.queryService.totalItems.posts || 0;
      case SearchTabsEnum.PROJECTS:
        return this.queryService.totalItems.projects || 0;
      case SearchTabsEnum.USERS:
        return this.queryService.totalItems.users || 0;
      case SearchTabsEnum.EVENTS:
        return this.queryService.totalItems.events || 0;
      case SearchTabsEnum.MARKETPLACE:
        return this.queryService.totalItems.marketplace || 0;
      default:
        return this.totalResults;
    }
  }

  constructor(
    public readonly appMain: SiteLayoutComponent,
    public readonly breadcrumb: AppBreadcrumbService,
    private readonly route: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly ms: ModalService,
    private readonly seo: SeoService,
    private readonly cacheRefresh: CacheRefreshService,
    private readonly hashtagRouting: HashtagRoutingService,
    private readonly queryService: QueryService
  ) {
    super();
  }
  ngOnInit(): void {
    this.config = {
      slidesPerView: 3,
      autoHeight: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    };
    this.subscriptions.push(this.route.queryParams.subscribe(({q}: {q: string}) => {
      this.applySearchContext(q || '', this.route.snapshot.params?.['slug'] || '', this.route.snapshot.data?.['mode'] || '');
      this.initMenuSlides();
      this.scheduleRefreshActiveList();
    }));
    this.subscriptions.push(this.route.params.subscribe((params) => {
      this.applySearchContext(this.route.snapshot.queryParams?.['q'] || '', params?.['slug'] || '', this.route.snapshot.data?.['mode'] || '');
      this.initMenuSlides();
      this.scheduleRefreshActiveList();
    }));
    this.subscriptions.push(this.breadcrumb.searchSubscriber.subscribe((query: string) => {
      if (!this.route.snapshot.url.join('/').includes('search-results') || this.isTagPage) {
        return;
      }
      this.breadcrumb.query = query || '';
      this.scheduleRefreshActiveList();
    }));
    this.subscriptions.push(this.breadcrumb.filtersClickedSubscriber.pipe(mergeMap(() => {
      return this.ms.showSearchFiltersModal({
        selectedTab: this.selectedTab,
        searchQuery: this.breadcrumb.query || ''
      }).successState;
    })).subscribe(() => {
      this.ms.close();
      this.refreshActiveList();
    }));
  }

  ngAfterViewInit(): void {
    // this.searchInfiniteListComponents.changes.subscribe((components: QueryList<SearchInfiniteListComponent>) => {
    //   components.forEach((component: SearchInfiniteListComponent) => {
    //     if (component.selectedTab.type === SearchTabsEnum.ALL) {
    //       component.initList();
    //     }
    //   });
    // });
  }

  public initMenuSlides(): void {
    this.slides = {};
    // this.tabs.forEach((tab) => this.slides[tab.type] = {label: tab.label, type: tab.type, count: 0, command: () => {}});
    const currentType = this.selectedTab?.type;
    this.selectedTab = this.tabs.find(t => t.type === currentType) || this.tabs.find(t => t.type === SearchTabsEnum.ALL);
    this.selectedIndex = Math.max(0, this.tabs.findIndex(t => t.type === this.selectedTab.type));
    this.childConfig = {
      slidesPerView: 1,
      autoHeight: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    };
  }

  selectChange(): void{
    this.slaveSwiper.swiperRef.slideTo(this.selectedIndex);
    this.slaveSwiper.swiperRef.updateSlidesClasses();
    this.selectedTab = this.tabs[this.selectedIndex];
    this.breadcrumb.filtersVisible = !this.isTagPage && !!this.selectedTab.filtersAvailable;
    this.searchInfiniteListComponents.forEach((component: SearchInfiniteListComponent) => {
      // component.items = [];
      // component.page = 2;
      // component.endOfResults = false;
      // component.ig.renderItems();
      // console.log(component);
    });
  }

  setActiveSlide(swiper: Swiper[]) {
    this.selectedIndex = swiper[0].activeIndex;
  }

  private scheduleRefreshActiveList(): void {
    setTimeout(() => this.refreshActiveList());
  }

  private refreshActiveList(): void {
    let refreshed = false;
    this.searchInfiniteListComponents.forEach((component: SearchInfiniteListComponent) => {
      if (component.selectedTab?.type !== this.selectedTab?.type) {
        return;
      }
      component.query = this.breadcrumb.query || '';
      component.items = [];
      component.page = 2;
      component.endOfResults = false;
      component.initList();
      refreshed = true;
    });

    if (!refreshed) {
      setTimeout(() => this.refreshActiveList());
    }
  }

  originalOrder(a: KeyValue<string, SwiperItemInterface>, b: KeyValue<string, SwiperItemInterface>): number {
    return (a.value.order || 0) > (b.value.order || 0) ? 1 : (b.value.order > a.value.order ? -1 : 0) ;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.appMain.topbarVisible = true;
    this.breadcrumb.searchInputVisible = false;
    this.searchInfiniteListComponents.destroy();
  }

  private applySearchContext(query: string, slug: string, routeMode: string): void {
    const normalizedSlug = this.hashtagRouting.normalizeSlug(slug);
    const normalizedQuery = (query || '').trim();
    const queryRepresentsTag = this.hashtagRouting.isExplicitTagQuery(normalizedQuery);

    this.isTagPage = routeMode === 'tag';
    this.isTagMode = routeMode === 'tag' || queryRepresentsTag;
    this.tagSlug = this.isTagMode
      ? (normalizedSlug || this.hashtagRouting.normalizeSlug(normalizedQuery))
      : null;
    this.exactTag = this.isTagMode ? this.tagSlug : null;
    this.searchTypes = this.isTagMode
      ? ['post', 'project', 'event', 'advertisement']
      : [];
    this.tabs = this.isTagMode ? this.tagTabsFactory() : this.defaultTabsFactory();

    const effectiveQuery = this.isTagMode && this.tagSlug
      ? this.hashtagRouting.buildTagQuery(this.tagSlug)
      : normalizedQuery;

    this.heading = this.isTagMode && this.tagSlug
      ? `#${this.tagSlug}`
      : (effectiveQuery || this.translate.instant('common.search_results'));
    this.breadcrumb.query = effectiveQuery;
    if (this.isTagPage && this.tagSlug) {
      this.breadcrumb.setItems([{label: `#${this.tagSlug}`, url: this.hashtagRouting.buildTagPath(this.tagSlug)} as MenuItem]);
    }
    setTimeout(() => {
      this.breadcrumb.searchInputVisible = !this.isTagPage;
      this.breadcrumb.filtersVisible = !this.isTagPage && !!this.selectedTab?.filtersAvailable;
      this.appMain.topbarVisible = this.isTagPage;
    });
    this.updateSeo(effectiveQuery);
  }

  private updateSeo(query: string): void {
    if (this.isTagMode && this.tagSlug) {
      const title = `#${this.tagSlug} - ${this.translate.instant('common.search_results')}`;
      const description = this.translate.instant('common.search_results') + `: #${this.tagSlug}`;
      const url = `${environment.appUrl}${this.hashtagRouting.buildTagPath(this.tagSlug)}`;
      this.seo.setTitle(title);
      this.seo.setDescription(description);
      this.seo.setOpenGraph({title, description, url, type: 'website'});
      this.seo.setCanonical(url);
      return;
    }

    const title = this.translate.instant('common.search_results') === 'common.search_results'
      ? 'Search results'
      : this.translate.instant('common.search_results');
    const description = this.translate.instant('meta.description') === 'meta.description'
      ? 'WTG | Watch This Garage.'
      : this.translate.instant('meta.description');
    const url = query && this.hashtagRouting.isExplicitTagQuery(query)
      ? `${environment.appUrl}${this.hashtagRouting.buildTagPath(query)}`
      : `${environment.appUrl}/search-results`;
    this.seo.setTitle(title);
    this.seo.setDescription(description);
    this.seo.setOpenGraph({title, description, url, type: 'website'});
    this.seo.setCanonical(url);
  }
}
